import React, { memo } from 'react'
import { SVGBackground } from './styles'

function random(min, max) {
  return Math.floor(Math.random() * (max - min) + min)
}

function Background() {
  return (
    <>
      <SVGBackground rotate={30} right={`${random(40, 45)}%`} top={`${random(5, 7)}%`} src="/assets/svg/1.svg" />
      <SVGBackground right={`${random(10, 15)}%`} top={`${random(10, 15)}%`} rotate={-20} src="/assets/svg/2.svg" />
      <SVGBackground right={`${random(25, 30)}%`} top={`${random(15, 20)}%`} rotate={30} src="/assets/svg/6.svg" />
      <SVGBackground right={`${random(50, 55)}%`} top={`${random(85, 90)}%`} rotate={40} src="/assets/svg/7.svg" />
      <SVGBackground right={`${random(10, 15)}%`} top={`${random(30, 35)}%`} rotate={30} src="/assets/svg/6.svg" />
      <SVGBackground right={`${random(55, 60)}%`} top={`${random(40, 45)}%`} rotate={40} src="/assets/svg/7.svg" />
      <SVGBackground right={`${random(30, 35)}%`} top={`${random(80, 85)}%`} rotate={30} src="/assets/svg/6.svg" />
      <SVGBackground right={`${random(55, 60)}%`} top={`${random(10, 15)}%`} rotate={40} src="/assets/svg/7.svg" />
    </>
  )
}

export default memo(Background)
